import { render, staticRenderFns } from "./OnlineBiddingList.vue?vue&type=template&id=7dd51b65&scoped=true&"
import script from "./OnlineBiddingList.vue?vue&type=script&lang=js&"
export * from "./OnlineBiddingList.vue?vue&type=script&lang=js&"
import style0 from "./OnlineBiddingList.vue?vue&type=style&index=0&id=7dd51b65&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd51b65",
  null
  
)

export default component.exports